import { LanguageUtils, SupportedLocale } from '@foundation/localization';

type DateTokens = {
  readonly day: string;
  readonly month: string;
  readonly year: string;
};

const DATE_PLACEHOLDER_EXCEPTIONS: Partial<
  Record<SupportedLocale, DateTokens>
> = {
  [SupportedLocale.Bulgarian]: { day: 'ДД', month: 'ММ', year: 'ГГГГ' },
  [SupportedLocale.ChineseSimplifiedChina]: {
    day: '日日',
    month: '月月',
    year: '年年年年',
  },
  [SupportedLocale.ChineseTraditionalHongKong]: {
    day: '日日',
    month: '月月',
    year: '年年年年',
  },
  [SupportedLocale.ChineseTraditionalTaiwan]: {
    day: '日日',
    month: '月月',
    year: '年年年年',
  },
  [SupportedLocale.Czech]: { day: 'DD', month: 'MM', year: 'RRRR' },
  [SupportedLocale.Danish]: { day: 'DD', month: 'MM', year: 'ÅÅÅÅ' },
  [SupportedLocale.Dutch]: { day: 'DD', month: 'MM', year: 'JJJJ' },
  [SupportedLocale.Estonian]: { day: 'PP', month: 'KK', year: 'AAAA' },
  [SupportedLocale.Finnish]: { day: 'PP', month: 'KK', year: 'VVVV' },
  [SupportedLocale.French]: { day: 'JJ', month: 'MM', year: 'AAAA' },
  [SupportedLocale.German]: { day: 'TT', month: 'MM', year: 'JJJJ' },
  [SupportedLocale.Hungarian]: { day: 'NN', month: 'HH', year: 'ÉÉÉÉ' },
  [SupportedLocale.Icelandic]: { day: 'DD', month: 'MM', year: 'ÁÁÁÁ' },
  [SupportedLocale.Japanese]: {
    day: '日日',
    month: '月月',
    year: '年年年年',
  },
  [SupportedLocale.Korean]: { day: '일일', month: '월월', year: '년년년년' },
  [SupportedLocale.Lithuanian]: { day: 'dd', month: 'mm', year: 'mmmm' },
  [SupportedLocale.Norwegian]: { day: 'DD', month: 'MM', year: 'ÅÅÅÅ' },
  [SupportedLocale.Polish]: { day: 'DD', month: 'MM', year: 'RRRR' },
  [SupportedLocale.Portuguese]: { day: 'DD', month: 'MM', year: 'AAAA' },
  [SupportedLocale.Russian]: { day: 'ДД', month: 'ММ', year: 'ГГГГ' },
  [SupportedLocale.Spanish]: { day: 'DD', month: 'MM', year: 'AAAA' },
  [SupportedLocale.Swedish]: { day: 'DD', month: 'MM', year: 'ÅÅÅÅ' },
  [SupportedLocale.Thai]: { day: 'วว', month: 'ดด', year: 'ปปปป' },
  [SupportedLocale.Turkish]: { day: 'GG', month: 'AA', year: 'YYYY' },
  [SupportedLocale.Ukrainian]: { day: 'ДД', month: 'ММ', year: 'РРРР' },
};

// Default fallback for en-US, id, it-IT, lv, ms-MY, ro-RO, vi
const DEFAULT_DATE_TOKENS: DateTokens = {
  day: 'DD',
  month: 'MM',
  year: 'YYYY',
};

export function dayPlaceholder(locale: string): string {
  const supportedLocale = LanguageUtils.locale(locale);
  if (!supportedLocale) {
    return DEFAULT_DATE_TOKENS.day;
  }

  return (
    DATE_PLACEHOLDER_EXCEPTIONS[supportedLocale]?.day ?? DEFAULT_DATE_TOKENS.day
  );
}

export function monthPlaceholder(locale: string): string {
  const supportedLocale = LanguageUtils.locale(locale);
  if (!supportedLocale) {
    return DEFAULT_DATE_TOKENS.month;
  }

  return (
    DATE_PLACEHOLDER_EXCEPTIONS[supportedLocale]?.month ??
    DEFAULT_DATE_TOKENS.month
  );
}

export function yearPlaceholder(locale: string): string {
  const supportedLocale = LanguageUtils.locale(locale);
  if (!supportedLocale) {
    return DEFAULT_DATE_TOKENS.year;
  }

  return (
    DATE_PLACEHOLDER_EXCEPTIONS[supportedLocale]?.year ??
    DEFAULT_DATE_TOKENS.year
  );
}
